import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { MutationOriginIntegrationUpdateArgs } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { UPDATE_ORIGIN_INTEGRATION } from "./gql";

const useUpdateOriginIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [originIntegrationUpdate, { loading }] = useMutation(UPDATE_ORIGIN_INTEGRATION);

  const updateOriginIntegration = useCallback(
    (input: MutationOriginIntegrationUpdateArgs, successCallback?: () => void) => {
      originIntegrationUpdate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.originIntegrationUpdate) {
            reportSuccess({
              message: `Origin integration was successfully updated`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration Edit - Finish", {
              integration: "Origin",
            });
          }
        })
        .catch(onError);
    },
    [originIntegrationUpdate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    updateOriginIntegration,
    loading,
  };
};

export default useUpdateOriginIntegration;
